import { FormItemController } from "./FormItemController";
import { MultiMedia } from "../../HTML/Form/Item/MultiMedia";
import { EditorMultiMedia } from "../../HTML/Editor/MultiMedia";
import { MediaContainer } from "../../HTML/Editor/MediaContainer";
import { toMap } from "../../../../HA";

export class MultiMediaController extends FormItemController {

    public getValue() {
        const list = this.getTag().getSelected(), res = [];

        list.forEach((item: any) => {
            if (item instanceof MediaContainer) {
                res.push(item.getFile());
            } else {
                res.push(item);
            }
        });

        return res;
    }

    public isInputItem() {
        return true;
    }

    protected createItem() {
        const data = toMap({tag: this.getTag()});
        this.attachModalEntry(data, (cfg) => new EditorMultiMedia(cfg));
        return new MultiMedia(data);
    }

    protected replaceItems(items: any[]) {
        this.getTag().replaceItems(items);
    }

    protected getChoices() {
        return this.getTag().getChoices();
    }
}
